import { apiFetch } from "@/utils";

function getCampaignsYear() {
  return apiFetch("campagne");
}

function getAllPeriods(year = -1) {
  if (year != -1)
    return apiFetch("periode?guid=&year=" + year);
  return apiFetch("periode");
}

function getAutoImport() {
  return apiFetch("periode/auto-import");
}

function toggleAutoImport(periodId) {
  return apiFetch("periode/toggle-auto-import?periodId=" + periodId);
}

export default { getCampaignsYear, getAutoImport, toggleAutoImport, getAllPeriods }
export { getCampaignsYear, getAutoImport, toggleAutoImport, getAllPeriods }



// WEBPACK FOOTER //
// ./src/utils/period.js